// import CircularProgress from '@material-ui/core/CircularProgress';
import Email from "@material-ui/icons/Email";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockOutlined from "@material-ui/icons/LockOutlined";
import PropTypes from "prop-types";
import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";

import BouncingLoader from "components/EnergyCompany/BouncingLoader/BouncingLoader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import { login } from "reducers/user/actions";
import { forgetPassword } from "services/auth";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

const styles = theme => ({
  ...loginPageStyle(theme),
  actionLink: {
    cursor: "pointer",
    marginTop: "10px",
  },
  container: {
    ...loginPageStyle(theme).container,
    paddingTop: "18vh",
  },
  loginButtonWrapper: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: theme.spacing.unit,
    position: 'relative',
  },
  titleActions: {
    color: "white",
    display: "flex",
    justifyContent: "center",
  },
});

class LoginPage extends Component {
  state = {
    error: false,
    forgetPassword: false,
    loading: false,
    password: "",
    updatingPasswordMsg: "",
    username: "",
  };

  componentWillMount() {
    if (this.props.user.access_token) {
      this.props.history.push("/dashboard");
    }
  }

  forgetPassword = () => {
    this.setState({
      forgetPassword: !this.state.forgetPassword,
      updatingPasswordMsg: "",
    });
  }

  handleClick = () => {
    this.state.forgetPassword ? this.sendForgetPasswordEmail() : this.login();
  }

  sendForgetPasswordEmail = () => {
    const { username } = this.state;
    this.setState({ loading: true, updatingPasswordMsg: "" });

    forgetPassword(username)
      .then(() => this.setState({ loading: false, updatingPasswordMsg: <span>E-mail enviado para <strong>{username}</strong></span> }))
      .catch((err) => {
        console.log(err);
      });
  }

  login = () => {
    const { username, password } = this.state;

    this.setState({ error: false, loading: true });

    this.props.login(username, password)
      .then(value => {
        this.setState({ error: false, loading: false });
        this.props.history.push("/dashboard");
      }).catch((err) => {
        this.setState({ error: true, loading: false });
      });
  }

  render() {
    const { classes } = this.props;
    const { error, forgetPassword, loading, password, updatingPasswordMsg, username } = this.state;

    return (
      <div className={classes.container}>
        <GridContainer alignContent="center" justify="center">
          <GridItem md={4} sm={6} xs={12}>
            <form>
              <ECCard
                content={
                  <div>
                    <div>
                      <CustomInput
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                          autoComplete: "username",
                          endAdornment: (
                            <InputAdornment position="end">
                              <Email className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          onChange: evt => this.setState({ username: evt.target.value }),
                          type: "email",
                        }}
                        labelText="Email"
                      />
                      {!forgetPassword && (
                        <CustomInput
                          formControlProps={{ fullWidth: true }}
                          inputProps={{
                            autoComplete: "current-password",
                            endAdornment: (
                              <InputAdornment position="end">
                                <LockOutlined className={classes.inputAdornmentIcon} />
                              </InputAdornment>
                            ),
                            onChange: evt => this.setState({ password: evt.target.value }),
                            type: "password",
                          }}
                          labelText="Senha"
                        />
                      )}
                    </div>
                    <div>{updatingPasswordMsg}</div>
                    <div className={classes.loginButtonWrapper}>
                      {loading ? <BouncingLoader /> : (
                        <div className={classes.loginButtonWrapper}>
                          <Button
                            color="rose"
                            disabled={!forgetPassword && (!username || !password || loading)}
                            onClick={this.handleClick}
                            size="lg"
                          >
                            {forgetPassword ? "Enviar e-mail" : "Entrar"}
                          </Button>
                          <a className={classes.actionLink} onClick={this.forgetPassword}>
                            {forgetPassword ? "Login?" : "Esqueceu a senha?"}
                          </a>
                          <a className={classes.actionLink} href="/cadastro">
                            Não tem conta? Cadastre-se
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                }
                hasIcon={false}
                title="Login"
                titleActionsClass={classes.titleActions}
              />
            </form>
            {error && <SnackbarContent color="rose" message={"Login ou senha inválidos."} />}
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = {
  login,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LoginPage));



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx